module.exports = __webpack_public_path__ + "img/ic-eye-open.49a19514.svg";